import { Route, Routes, useLocation } from 'react-router'
import { observer, inject } from 'mobx-react'

import AuthCheck from './AuthCheck'
import ErrorBoundary from './components/ErrorBoundary'
import { Onboarding, Main, Offboarding } from './views'
import UpgradeProduct from './views/offboarding/upgrade-product/UpgradeProduct'
import Cancellation from './views/offboarding/transactions/Cancellation'
import Discontinue from './views/profile/services/Discontinue'
import Advice from './views/advice'
import { HeyNicRoutes } from './views/hey-nic'
import { AiDisclaimerPage } from './views/legal'
import SuccessMessage from './views/login/SuccessMessage'
import ThemeWrapper from './themes/ThemeWrapper'
import AutoLogoutModal from './components/AutoLogoutModal'

function AuthenticatedApp() {
  const location = useLocation()

  return (
    <div>
      <ErrorBoundary resetKey={location.key}>
        <Routes>
          <Route path='/discontinue' element={<Discontinue />} />
          <Route path='/cancel' element={<Cancellation />} />
          <Route path='/atmos/change-username/complete' element={<SuccessMessage />} />
          <Route path='/product-select' element={<UpgradeProduct />} />
          <Route path='/welcome/*' element={<Onboarding />} />
          <Route path='/implement/*' element={<Offboarding />} />
          <Route path='/implement-changes/*' element={<Offboarding />} />
          <Route path='/advice/*' element={<Advice />} />
          <Route path='/hey-nic/*' element={<HeyNicRoutes />} />
          <Route path='/ai-disclaimer' element={<AiDisclaimerPage />} />
          <Route path='/*' element={<Main />} />
        </Routes>
      </ErrorBoundary>
    </div>
  )
}

function GatewayApp(props) {
  const { isAuthenticated } = props.store.auth

  return (
    <div>
      <Routes>
        <Route
          path='/*'
          element={
            isAuthenticated ? (
              // Members without plan access can't load an org theme, so use the default.
              <ThemeWrapper isAuth={props.store.hasPlanAccess}>
                <AuthenticatedApp />
                <AutoLogoutModal />
              </ThemeWrapper>
            ) : (
              <AuthCheck />
            )
          }
        />
      </Routes>
    </div>
  )
}

export default inject('store')(observer(GatewayApp))
